// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__czqbS","sectionHeader":"Section_sectionHeader__ba1Cb","title":"Section_title__CqDTb","link":"Section_link__BfQud"};